import React from 'react';
import { connect } from 'react-redux';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import cards from './images/cards.svg';

const Payment = (props) => {
  const iframeHeight = props.iframeHeight || (props.type == '2' ? '500px' : '562px');

  return (
    <div className={`payment${props.className ? ` ${props.className}` : ''}`}>
      {props.iframeUrl && (
        <>
          <iframe
            frameBorder='0'
            scrolling={props.allowScroll ? 'yes' : 'no'}
            className='nvc-iframe'
            src={props.iframeUrl}
            title=''
            style={{ height: iframeHeight }}
            onLoad={props.onIframeLoad}
          />
          {!props.hideInfo && (
            <div className='info-wrapper'>
              <p>
                {' '}
                לא כולל כרטיסי דיירקט
                <span className='cards-img' style={{ backgroundImage: cards.bg() }} />
              </p>
              <p dir='rtl'>רכישה מאובטחת ב - SSL</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    iframeUrl: state.saleJetBlock.paymentInfo.iframeUrl,
  };
};

const mapDispatchToProps = {
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment);
